import { render, staticRenderFns } from "./Thumb.vue?vue&type=template&id=0286509e&scoped=true&"
import script from "./Thumb.vue?vue&type=script&lang=js&"
export * from "./Thumb.vue?vue&type=script&lang=js&"
import style0 from "./Thumb.vue?vue&type=style&index=0&id=0286509e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0286509e",
  null
  
)

export default component.exports